import { render, staticRenderFns } from "./inspectionsUnitType.vue?vue&type=template&id=254b2070&"
import script from "./inspectionsUnitType.vue?vue&type=script&lang=js&"
export * from "./inspectionsUnitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports